<pre>
  @for (line of (xml$ | async); track trackByFn($index)) {
    <code>{{line}}</code>
  }
</pre>
